export default __webpack_public_path__ + "img/97f4064bec7788545c387300f1b712ef.png";